import React from "react";
import { useStyles } from "./styles";
import { useAgendaState } from "./useAgendaState";
import { GridView } from "./GridView";

import { ConfirmDialog } from "./ConfirmDialog";
import { Row } from "./types";
import { useHistory } from "react-router-dom";

const eNum = (r: Row) => "E" + (r.edit || 1);

const WritersAgendaV2: React.FC = () => {
  const classes = useStyles();
  const ctl = useAgendaState();
  const { state, dispatch, ckPending, cmSent, isLoading } = ctl;
  const history = useHistory();

  const unreadFor = React.useCallback(
    (r: Row) => {
      if (r.st === "corr_rev") return ckPending.some((i) => !i.ack);
      if (r.st === "corr_ver") return cmSent("verify").some((c) => !c.ack);
      if (r.st === "corr_app") return cmSent("approval").some((c) => !c.ack);
      return false;
    },
    [ckPending, cmSent],
  );

  const openRow = ctl.openRow;

  const handleCreateReport = React.useCallback(
    (report: Row) => {
      history.push(
        `/reports/report_writers_agenda/tiptap/${report.id}?mode=new&status=${report.st}&role=${ctl.state.role}&url_param=${report.url_param}`,
      );
    },
    [history, ctl.state.role],
  );

  const handleContinueReport = React.useCallback(
    (report: Row) => {
      history.push(
        `/reports/report_writers_agenda/tiptap/${report.id}?mode=continue&status=${report.st}&role=${ctl.state.role}&url_param=${report.url_param}`,
      );
    },
    [history, ctl.state.role],
  );

  return (
    <div className={classes.root}>
      <GridView
        ctl={ctl}
        eNum={eNum}
        unreadFor={unreadFor}
        onCreateReport={handleCreateReport}
        onContinueReport={handleContinueReport}
        loading={isLoading}
        completedRows={ctl.completedRows}
      />

      <ConfirmDialog
        open={Boolean(state.confirm)}
        title={state.confirm?.title || ""}
        body={state.confirm?.body || ""}
        label={state.confirm?.label || "Confirm"}
        onCancel={() => dispatch({ type: "CLOSE_CONFIRM" })}
        onConfirm={() => {
          state.confirm?.onConfirm();
          dispatch({ type: "CLOSE_CONFIRM" });
        }}
      />
    </div>
  );
};

export default WritersAgendaV2;
